import { render } from "./OrderEdit.vue?vue&type=template&id=18d29c3a&scoped=true"
import script from "./OrderEdit.vue?vue&type=script&lang=js"
export * from "./OrderEdit.vue?vue&type=script&lang=js"

import "./OrderEdit.vue?vue&type=style&index=0&id=18d29c3a&lang=scss&scoped=true"

import exportComponent from "/Users/yllian/RolnnData/Project/m2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d29c3a"]])

export default __exports__